import { render, staticRenderFns } from "./StuPictureCon.vue?vue&type=template&id=58b31e35&scoped=true"
import script from "./StuPictureCon.vue?vue&type=script&lang=js"
export * from "./StuPictureCon.vue?vue&type=script&lang=js"
import style0 from "./StuPictureCon.vue?vue&type=style&index=0&id=58b31e35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b31e35",
  null
  
)

export default component.exports